// main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { lightTheme, darkTheme } from "./theme";
import ThemeModeProvider, {
  ThemeModeContext,
} from "./providers/themeModeContext";
import App from "./App";
import "./firebaseApp";
import { UsuarioProvider } from "./providers/usuarioProvider";
import "./assets/fonts.css";

// Componente wrapper para evitar re-renders desnecessários
function ThemeWrapper() {
  return (
    <ThemeModeContext.Consumer>
      {(themeMode) => (
        <ThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
          <CssBaseline />
          <UsuarioProvider>
            <App />
          </UsuarioProvider>
        </ThemeProvider>
      )}
    </ThemeModeContext.Consumer>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <ThemeWrapper />
    </ThemeModeProvider>
  </React.StrictMode>
);
